export { VirtualCardFulfillmentMyExtend as default } from './virtual-card-fulfillment'
